import { FC } from 'react'

import { styled } from 'styled-components'

import FormLabel from 'core/components/lib/FormLabel'
import { useRect, useBorrowerIsMobile } from 'core/hooks'
import { onSurfaceDim } from 'core/styles'

const Optional = styled.div<{ paddingLeft?: string }>`
  padding-left: ${(p) => p.paddingLeft || '0px'};
  letter-spacing: 0.5px;
  color: ${onSurfaceDim};
  font-size: 12px;
  font-weight: 500;
`

export const Container = styled.div<{ margin?: string }>`
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin: ${(p) => p.margin};
`

export const Label = styled(FormLabel)<{
  labelWidth?: string
  shortLabel?: string
}>`
  flex: 0 0 ${(p) => p.labelWidth || (p.shortLabel ? '40px' : '240px')};
`

const Content = styled.div`
  grid-column: 2/3;
`

const BlockContainer = styled.div<{ margin?: string }>`
  margin: ${(p) => p.margin};
`
const BlockLabel = styled(FormLabel)`
  display: block;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
`

const BlockContent = styled.div`
  padding: 8px;
`

const Labels = styled.div`
  grid-column: 1;
  margin-right: 50px;
`

type Props = {
  formKey?: string
  label?: string
  shortLabel?: string
  bare?: boolean
  compact?: boolean
  optional?: boolean
  margin?: string
  children?: any
  labelWidth?: string
}

const ItemLabel: FC<Props> = ({ label, optional, children, compact, margin, shortLabel, labelWidth }) => {
  const labelSuffix = optional && <Optional paddingLeft={compact ? '8px' : ''}>OPTIONAL</Optional>

  const isMobile = useBorrowerIsMobile()
  const [{ width }, ref] = useRect()

  const isCompact = compact || isMobile || width < 400

  return isCompact ?
      <BlockContainer margin={margin || '8px'} ref={ref}>
        {label && (
          <>
            <BlockLabel text={label} />
            {labelSuffix}
          </>
        )}
        <BlockContent>{children}</BlockContent>
      </BlockContainer>
    : <Container margin={margin || '24px'} ref={ref}>
        <Labels>
          {label && (
            <>
              <Label labelWidth={labelWidth} shortLabel={shortLabel} text={label} />
              {labelSuffix}
            </>
          )}
        </Labels>
        <Content>{children}</Content>
      </Container>
}

export default ItemLabel
